import React from "react";
import ModalDeprecated from "../components/ModalDeprecated";

const DeprecatedPage = () => {
  return (
    <div>
      <ModalDeprecated show />
    </div>
  );
};

export default DeprecatedPage;
